/* หมวดวัสดุ */
import React from "react";
import { Col, Form, Input, InputNumber, Row, Select } from "antd";
import CrudPage from "../../../components/ak/CrudPage";
import StatusTag from "../../../components/ak/StatusTag";
import { MaterialCategoryService } from "../../../service/Ak.service";

export default function MaterialCategoryPage() {
  return (
    <CrudPage
      title="หมวดวัสดุ"
      subtitle="ใช้จัดกลุ่มวัสดุและจุดที่ให้ลูกค้าเลือก"
      menu="master_material_category"
      rowKey="cat_code"
      service={MaterialCategoryService}
      addText="เพิ่มหมวด"
      activeFilter={false}
      deleteText="ลบ"
      deleteConfirm="ลบหมวดนี้? (ลบได้เฉพาะหมวดที่ยังไม่มีวัสดุ)"
      canDeleteRecord={(r) => Number(r.material_count) === 0}
      modalWidth={520}
      initialValues={{ seq: 99, active_status: "Y" }}
      renderForm={(form, editing) => (
        <Row gutter={12}>
          <Col xs={24} md={10}>
            <Form.Item name="cat_code" label="รหัสหมวด" rules={[{ required: true, message: "กรอกรหัส" }, { pattern: /^[A-Za-z0-9_-]+$/, message: "ใช้ได้เฉพาะ A-Z 0-9 _ -" }]}>
              <Input maxLength={20} disabled={!!editing} placeholder="เช่น FLOOR" />
            </Form.Item>
          </Col>
          <Col xs={24} md={14}>
            <Form.Item name="cat_name" label="ชื่อหมวด" rules={[{ required: true, message: "กรอกชื่อหมวด" }]}>
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item name="seq" label="ลำดับ">
              <InputNumber min={1} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item name="active_status" label="สถานะ">
              <Select options={[{ value: "Y", label: "ใช้งาน" }, { value: "N", label: "ปิดใช้งาน" }]} />
            </Form.Item>
          </Col>
        </Row>
      )}
      columns={() => [
        { title: "ลำดับ", dataIndex: "seq", width: 70, align: "center" },
        { title: "รหัส", dataIndex: "cat_code", width: 120 },
        { title: "ชื่อหมวด", dataIndex: "cat_name" },
        { title: "จำนวนวัสดุ", dataIndex: "material_count", align: "center", width: 110 },
        { title: "สถานะ", dataIndex: "active_status", width: 100, render: (v) => <StatusTag value={v} /> },
      ]}
    />
  );
}
